import { render, staticRenderFns } from "./InitializeFeedbackForBranch.vue?vue&type=template&id=8f9daedc&scoped=true"
import script from "./InitializeFeedbackForBranch.vue?vue&type=script&lang=js"
export * from "./InitializeFeedbackForBranch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f9daedc",
  null
  
)

export default component.exports